import { Component, Input, OnInit, SimpleChanges, ViewChild,OnChanges, AfterViewInit, EventEmitter, Output } from '@angular/core';
import * as constant from './../shared/constants/constants';
import { MatSort, Sort } from '@angular/material/sort';
import { UtilService } from '../shared/services/util.service';
import { ResponsiveService } from '../shared/responsive/responsive.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ScenerioService } from '../shared/services/scenerio.service';
import { ExceptionService } from '../shared/services/exception.service';
import { UrlSecurityService } from '../shared/services/url-security.service';
import { function_calculation_type, priceSensitivity, priceSensitivityTextColor, recalculate_errors, recalculation_type, scenario_error, uploadError } from '../core/enum';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from '../shared/services/storage.service';
// import * as moment from 'moment';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { EstimatedImpactInterface } from '../shared/interfaces/impact_interface';
import { PriceChangeSKU, SKU_TABLE_DETAILS } from '../shared/interfaces/sku_table_interface';
import { TranslateService } from '@ngx-translate/core';
import { RecommendationService } from '../shared/services/recommendation.service';

import { MatDatepicker } from '@angular/material/datepicker';
import { Moment} from 'moment';
import * as _moment from 'moment';
import { FormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { sortArrayOfObjects } from '../shared/directives/sortArrayOfObjects';

const moment = _moment;

export const MONTH_YEAR_FORMAT = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface ScenarioFilters {
  category_l1: boolean;
  category_l2: boolean;
  subcategory: boolean;
  product: boolean;
}


@Component({
  selector: 'app-scenario-sku-level-table',
  templateUrl: './scenario-sku-level-table.component.html',
  styleUrls: ['./scenario-sku-level-table.component.scss'],
  providers : [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
  
    {provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMAT},
  ]
})
export class ScenarioSKULevelTableComponent implements OnInit, OnChanges, AfterViewInit {

  /** Input variable to get data */
  @Input('scenarioSKULevelDetails') scenario_sku_level_details: any = [] as SKU_TABLE_DETAILS[];
  @Input('scenarioID') scenario_id: any;
  @Output('scenarioSkuLevelDetailsChanged') scenario_sku_level_details_changes: any; 
  @Input('ptSettings') pt_settings: any;

  /** Table Variable */
  price_tier_table_columns: any;
  data_source = new MatTableDataSource<any>();
  price_tier_table_data: any = [];
  copy_price_tier_data: any =[]
  @ViewChild(MatSort) sort: MatSort;

  /** paginator variables */
  @ViewChild('paginator') paginator: MatPaginator;
  page_index = constant.common.zero;
  page_size: number = constant.common.default_page_size;
  count: number;
  @Output() paginationCall: EventEmitter<any> = new EventEmitter<any>();

  /** Category DropdownVariables */
  category_data: any = [];
  selected_category: any = [];
  applied_categories:any = [];

  /** Category L2 Dropdoqn Variables*/
  category_l2_data: any = [];
  selected_category_l2: any = [];
  applied_categories_l2: any = [];

  /** Sub Category DropdownVariables */
  sub_category_data: any = [];
  selected_sub_category: any = [];
  applied_sub_categories: any = [];

  /**Filter variables */
  selected_price_band: any = constant.common.defaultRegion;
  price_band_data: any= [];
  applied_price_band: any  = constant.common.defaultRegion;
  geo_code: any = constant.common.defaultRegionCode;
  geo_id :any = constant.common.defaultRegionId;
  // price_band_id: any;
  selected_product_name: any = [];
  product_name_data: any= [];
  applied_product_name: any = [];

  /** Column DropdownVariables */
  column_data: any = [];
  selected_column: any = [];
  applied_columns:any = [];

  price_sensitivity: any;
  price_sensitivity_text_color: any;
  configuration: any; 

  /**price change parameters */
  price_change = new Map();
  is_validate_price_enable: boolean = false;
  price_changed_items: any = [] as SKU_TABLE_DETAILS[]  


  /**sku Level Save Confirm Pupup */
  sku_level_save_confirm_pupup: string = constant.common.display_none;
  sku_level_new_scenario: string = constant.common.display_none;
  rules_violation_popup : string = constant.common.display_none;
  reset_recommendation_popup : string = constant.common.display_none;
  reset_current_popup : string = constant.common.display_none;

  /**Scenario Crearion */
  name: any;
  description: any;
  pricing_cycle_date: any;
  
  /** Enum of Recalculation */
  recalculation_type : any = recalculation_type;
  function_calculation_type : any = function_calculation_type; 
  recalculate_errors : any = recalculate_errors;

  /** Sorting Variables */
  sorting_column:any = constant.scenario.default_sorting_column;
  sorting_type:any = constant.scenario.default_sorting_direction;

  /** Rule Violation PopUp Variable */
  is_rule_violation:boolean = false;
  rule_violation_path: any = undefined;

  /** Minimum Date for Save PopUP Planning Cycle Date */
  min_date = new Date();

  /** Varibles to Check file or recalculation logs */
  is_file_uploaded : boolean = false;
  is_item_recalculated: boolean = false;

  /** Toggle Variables */
  is_recommended_price_change: boolean =false;
  is_producted_affected: boolean = false;
  is_price_change: boolean = false;
  is_alert_toggle_disabled : boolean = false;
  price_analysis_required : boolean = false;
  
  /** Price Hierarchy Popup Variables */
  price_hierarchy_pop_up_settings: any ={open : constant.common.none}
  price_hierarchy_enable:any = true;
  is_reset_price_hierarchy: any = false;

  /**Date formatter */
  date = new FormControl(moment());

  pbrSettings: any = {};

  /** Recalculate Price Change Flag */
  is_recalculate_price_change : boolean = false;

  scenario_filters :ScenarioFilters ;
  item_affected:any = null;


  constructor(
    public utilService: UtilService,
    public responsiveService: ResponsiveService,
    private router: Router,
    private scenerioService: ScenerioService,
    private recommenderService: RecommendationService,
    private exceptionService: ExceptionService,
    public route: ActivatedRoute,
    private urlService: UrlSecurityService,
    private storageService: StorageService,
    private toastrService: ToastrService,
    private translateService : TranslateService,
    private activatedRoute: ActivatedRoute
  ) { 
    this.activatedRoute.queryParams.subscribe(params => {
      this.pbrSettings =  JSON.parse(this.urlService.decryptUsingAES256(params['pbrSettings']))
      this.is_file_uploaded = this.pbrSettings.is_upload;
      this.is_item_recalculated = this.pbrSettings.is_calculated;
      this.is_rule_violation = this.pbrSettings.is_rule_violation;
      this.is_alert_toggle_disabled = this.pbrSettings.is_alert_toggle_disabled;
      this.is_recalculate_price_change = this.pbrSettings.is_recalculate_price_change;
    });
    this.scenerioService.price_hierarchy.subscribe((value:any)=>{
      if(value.data.length>0){
        this.price_hierarchy_enable = false;
      }
    })
  }

  ngOnInit(): void {
    this.price_sensitivity = priceSensitivity;
    this.price_sensitivity_text_color = priceSensitivityTextColor;
    this.price_tier_table_columns = constant.scenario.table_columns_with_price_tier;
    this.date.disable();
    this.getCofigValuesFromSession();
    this.getScenarioFiltersConfig();
  }

  /**
 * Fetches scenario filter configuration from the backend
 * and based on the filter flags (true/false),
 * triggers the corresponding API calls to load data.
 */
  getScenarioFiltersConfig() {
    this.scenerioService.getScenarioFilters().subscribe({
      next: (response: any) => {
        this.scenario_filters = response
        this.handleScenarioFilterResponse()
      }
    })
  }

  handleScenarioFilterResponse(){
        this.scenario_filters?.category_l1 && this.getCategoryData();
        this.scenario_filters?.category_l2 && this.getL2CategoryData();
        this.scenario_filters?.subcategory && this.getSubCategoryData();
        this.scenario_filters?.product && this.getProductNameData();
  }


  /** Get SKU Details API Call */
  getSKUDetails() {
    if (!this.utilService.isNullOrEmptyOrUndefined(this.scenario_sku_level_details) && !this.utilService.isNullOrEmptyOrUndefined(this.pt_settings)) {
      if(this.pt_settings.reset_categories){
        this.selected_category = [];
        this.applied_categories = [];
        this.page_index = constant.common.zero;
        this.page_size = constant.common.default_page_size;
        this.pt_settings.reset_categories = false;
      }
      this.loadinitialTableData(this.scenario_sku_level_details);
      this.priceTierColumnBasedonCofiguration(this.pt_settings);
      // this.getCategoryData();
    }
  }

  /** Price Tier Column Based on Cofiguration */ 
  priceTierColumnBasedonCofiguration(pt_settings: any) {
    pt_settings.view_price_band_scenario == true ? this.price_tier_table_columns = constant.scenario.table_columns_without_price_tier : this.price_tier_table_columns = constant.scenario.table_columns_with_price_tier;
    if(pt_settings.view_price_band_scenario == true) this.column_data = constant.scenario.column_selection.filter(item => item.column_id !== 'price_tier');
    if(pt_settings?.is_remove_final_store) this.price_tier_table_columns = this.price_tier_table_columns.filter((item:any)=>{ return item !== "scenario_price"})
    if(pt_settings?.is_remove_final_store) this.column_data = this.column_data.filter((item:any)=>{ return item.column_id !== "scenario_price"})
    this.column_data = sortArrayOfObjects(this.column_data, 'column_name', 'ascending');
  } 
  
  /** To Capture Price Tier Changes */
  ngOnChanges(changes: SimpleChanges){
    this.getSKUDetails()  
    if(this.selected_column.length != 0) {
      this.applySelectedColumns();
    }
    if(changes['pt_settings']?.currentValue?.scenario_id !== changes['pt_settings']?.previousValue?.scenario_id){
      this.getPriceBandData()
      this.handleScenarioFilterResponse();
    }
  }

  ngAfterViewInit(): void {
    // If the user changes the sort order, reset back to the first page.
    // this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
  }

  /** Get Config Values From Session Storage */
  async getCofigValuesFromSession() {
    this.configuration = await this.storageService.get(constant.storage_keys.configuration);
  }


  /** Function to get Category Data */
  getCategoryData() {
    if (!this.utilService.isNullOrEmptyOrUndefined(this.pt_settings)) {
      if (this.pt_settings.create_scenario) {
        this.scenerioService.getTempL1CategoryDropdownDetails(this.categoryL1Dto(true)).subscribe((response:any)=>{
          this.category_data = response;
          this.clearData(this.category_data,this.selected_category, 'category_lvl1_id');
        });
      }
      else {
        this.scenerioService.getL1CategoryDropdownDetails(this.categoryL1Dto(false)).subscribe((response: any) => {
          this.category_data = response;
          this.clearData(this.category_data,this.selected_category, 'category_lvl1_id');
        });
      }
    }
  }

  /** Function to get L2 Category Data */
  getL2CategoryData() {
    if (this.pt_settings.create_scenario) {
      this.scenerioService.getTempL2CategoryDropdownDetails(this.categoryL2Dto(true)).subscribe((response: any) => {
        this.category_l2_data = response;
        this.clearData(this.category_l2_data,this.selected_category_l2, 'category_lvl2_id');
      });
    }
    else {
      this.scenerioService.getL2CategoryDropdownDetails(this.categoryL2Dto(false)).subscribe((response: any) => {
        this.category_l2_data = response;
        this.clearData(this.category_l2_data,this.selected_category_l2, 'category_lvl2_id');
      });
    }
  }

  /** Function to get Sub Category Data */
  getSubCategoryData() {
    if (this.pt_settings.create_scenario) {
      this.scenerioService.getTempSubCategoryDropdownDetails(this.subCategoryDto(true)).subscribe((response: any) => {
        this.sub_category_data = response;
        this.clearData(this.sub_category_data,this.selected_sub_category, 'sub_category_id');
      });
    }
    else {
      this.scenerioService.getSubCategoryDropdownDetails(this.subCategoryDto(false)).subscribe((response: any) => {
        this.sub_category_data = response;
        this.clearData(this.sub_category_data,this.selected_sub_category, 'sub_category_id');
      });
    }
  }

  /** Function to get Price Band Data */
  getPriceBandData(){
    if (!this.utilService.isNullOrEmptyOrUndefined(this.pt_settings)) {
      if(this.pt_settings.view_scenario){
        this.recommenderService.getPriceBandDetails(this.priceBandDto()).subscribe((response: any) => {
          this.price_band_data = response;
        })
      }
    }
  }

  /** Function to get Product Name Data */
  getProductNameData() {
    if (!this.utilService.isNullOrEmptyOrUndefined(this.pt_settings)) {
      if (this.pt_settings?.create_scenario) {
        this.scenerioService.getTempItemDropdownDetails(this.productNameDto(true)).subscribe((response: any) => {
          this.product_name_data = response;
          this.clearData(this.product_name_data,this.selected_product_name, 'product_id');
        })
      } else {
        this.scenerioService.getItemDropdownDetails(this.productNameDto(false)).subscribe((response: any) => {
          this.product_name_data = response;
          this.clearData(this.product_name_data,this.selected_product_name, 'product_id');
        })
      }
    }
  }

  // /** Function to get Temp Product Details Data */
  // getTempProductDetails(){
  //   this.scenerioService.getTempItemDropdownDetails(this.tempProductNameDto()).subscribe((response: any) => {
  //     this.product_name_data = response;
  //   })
  // }

  /** Category DTO function */
  categoryL1Dto(isTemp:boolean){
    let category_lvl2_id : any = this.selected_category_l2.map((value: any) => {
      return this.urlService.encrypt(value.category_lvl2_id);
    });
    let sub_category :any = this.selected_sub_category.map((value: any) => {
      return this.urlService.encrypt(value.sub_category_id);
    });
    let product_name: any = this.selected_product_name.map((value: any) => {
      return this.urlService.encrypt(value.product_id);
    });
    let payload: any = {};
    if(this.pt_settings.scenario_id)payload["scenario_id"] = this.urlService.encrypt(this.pt_settings.scenario_id);
    payload['category_lvl2_id'] = category_lvl2_id
    payload["sub_category"] = sub_category;
    payload['product_id'] = product_name;
    payload["geo_id"] = this.urlService.encrypt(this.pt_settings.geo_id.toString()) ;
    isTemp ? payload["request_id"] = this.pt_settings.request_id : ''
    return payload;
  }

  /** L2 Category DTO function */
  categoryL2Dto(isTemp:boolean) {
    let categories: any = this.selected_category.map((value: any) => {
      return this.urlService.encrypt(value.category_lvl1_id);
    });
    let sub_category :any = this.selected_sub_category.map((value: any) => {
      return this.urlService.encrypt(value.sub_category_id);
    });
    let product_name: any = this.selected_product_name.map((value: any) => {
      return this.urlService.encrypt(value.product_id);
    });
    let payload: any = {};
    if (this.pt_settings.scenario_id) payload["scenario_id"] = this.urlService.encrypt(this.pt_settings.scenario_id);
 // payload["geo_id"] = this.pt_settings.view_price_band_scenario && this.pt_settings.geo_id != "" ? this.urlService.encrypt(this.pt_settings.geo_id.toString()) : this.urlService.encrypt(this.geo_id.toString());
 payload["geo_id"] = this.urlService.encrypt(this.pt_settings.geo_id.toString()) ;
    payload['category_lvl1_id'] = categories;
    payload["sub_category"] = sub_category;
    payload['product_id'] = product_name;
    isTemp ? payload["request_id"] = this.pt_settings.request_id : ''
    return payload;
  }

  /** Sub Category DTO function */
  subCategoryDto(isTemp:boolean) {
    let categories: any = this.selected_category.map((value: any) => {
      return this.urlService.encrypt(value.category_lvl1_id);
    });
    let category_lvl2_id : any = this.selected_category_l2.map((value: any) => {
      return this.urlService.encrypt(value.category_lvl2_id);
    });
    let product_name: any = this.selected_product_name.map((value: any) => {
      return this.urlService.encrypt(value.product_id);
    });
    let payload: any = {};
    if (this.pt_settings.scenario_id) payload["scenario_id"] = this.urlService.encrypt(this.pt_settings.scenario_id);
 // payload["geo_id"] = this.pt_settings.view_price_band_scenario && this.pt_settings.geo_id != "" ? this.urlService.encrypt(this.pt_settings.geo_id.toString()) : this.urlService.encrypt(this.geo_id.toString());
 payload["geo_id"] = this.urlService.encrypt(this.pt_settings.geo_id.toString()) ;
    payload['category_lvl1_id'] = categories;
    payload['category_lvl2_id'] = category_lvl2_id;
    payload['product_id'] = product_name;
    isTemp ? payload["request_id"] = this.pt_settings.request_id : ''
    return payload;
  }

  /** Price Band DTO function */
  priceBandDto(){
    let payload: any = {};
    if(this.pt_settings.scenario_id)payload["scenario_id"] = this.urlService.encrypt(this.pt_settings.scenario_id);
    return payload;
  }

  /** Product Name DTO function */
  productNameDto(isTemp:boolean) {
    let categories: any = this.selected_category.map((value: any) => {
      return this.urlService.encrypt(value.category_lvl1_id);
    });
    let category_lvl2_id : any = this.selected_category_l2.map((value: any) => {
      return this.urlService.encrypt(value.category_lvl2_id);
    });
    let sub_category :any = this.selected_sub_category.map((value: any) => {
      return this.urlService.encrypt(value.sub_category_id);
    });
    let payload: any = {};
    if (this.pt_settings.scenario_id) payload["scenario_id"] = this.urlService.encrypt(this.pt_settings.scenario_id);
 // payload["geo_id"] = this.pt_settings.view_price_band_scenario && this.pt_settings.geo_id != "" ? this.urlService.encrypt(this.pt_settings.geo_id.toString()) : this.urlService.encrypt(this.geo_id.toString());

     payload["geo_id"] = this.urlService.encrypt(this.pt_settings.geo_id.toString()) ;
    isTemp ? payload["request_id"] = this.pt_settings.request_id : ''
    payload["category_lvl1_id"] = categories;
    payload["category_lvl2_id"] = category_lvl2_id;
    payload["sub_category"] = sub_category;
    return payload;
  }

  /** Only Numbers */
  onlyNumberKey(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode

    if ((charCode < 48 || charCode > 57) && charCode != 8 && charCode != 44 && charCode != 46) {
      return false;
    }
    return true;
  }

  /** Load Initial Table Data */
  loadinitialTableData(response: any) {
    this.price_tier_table_data = response;
    this.column_data = constant.scenario.column_selection.map((value: any) => {
      value['column_name'] = this.utilService.languageTranslator(value['column_name']);
      return value;
    });
    this.validatePriceCalculation();
  }

  /** Validating Price Calculation */
  validatePriceCalculation() {
    this.price_tier_table_data.forEach((object: any) => {
      object.current_price = +parseFloat(object.current_price.toString()).toFixed(this.configuration.decimal_points),
        object.recommended_price = +parseFloat(object.recommended_price.toString()).toFixed(this.configuration.decimal_points),
        object.scenario_price = this.utilService.languageSensitiveFormatting(parseFloat(object.scenario_price).toFixed(this.configuration.decimal_points))
        object.scenario_detail_id = object.geo_code + ":" + object.sku_id;
    })
    this.copyPriceTierDataWithoutFilter()
  }

  /** Copying the Original Data for Filtering */
  copyPriceTierDataWithoutFilter(){
    this.copy_price_tier_data = JSON.parse(JSON.stringify(this.price_tier_table_data))
    this.filterData()
  }
  
  /** All Filter Data Function */
  filterData(){
    this.filterTableByCategory();
    this.loadPriceTierTableData();
  }

  /** Load Price Tier Table Data */
  loadPriceTierTableData(){
    this.data_source = new MatTableDataSource(this.copy_price_tier_data);
    this.count = this.pt_settings['total_count'];
  }

  /** Function Filter Data By Category */
  filterTableByCategory() {
  this.copy_price_tier_data =  this.copy_price_tier_data.filter((restaurant: any) =>
      this.selected_category.length === 0 || this.selected_category.some((category: any) =>
        restaurant.category_name === category.category_name));
  }

  /**To navigate back to scenario landing page */
  backToScenario() {
    this.router.navigate([constant.navigation.scenarioLanding]);
  }

  /** Price Metric Calculation With Percentage Decimal */
  priceMetricCalculationWithPercentageDecimal(value: any) {
    return this.utilService.priceMetricCalculationWithDecimalService(value, this.configuration.percentage_decimal);
  }

  /** Price Metric Calculation With Two Decimal */
  priceMetricCalculationWithTwoDecimal(value: any) {
    return this.utilService.priceMetricCalculationWithDecimalService(value, this.configuration.decimal_points);
  }

  /** onChange price change evetn */
  async onValidatePriceChange(current_price: any, scenario_detail_id: any, event: any, item: any) {
    let newPrice = event.target.value.replace(",", ".")
    this.validatePriceChange(current_price, newPrice, scenario_detail_id, item);
  }

  /** price change validation */
  validatePriceChange(currentPrice: any, newPrice: any, itemCode: any, item: any) {
    if (this.utilService.validateNumberCheck(newPrice) == this.utilService.validateNumberCheck(currentPrice.toString())) {
      this.removePriceChangeItem(itemCode);
    } else {
      this.price_changed_items = this.price_changed_items.filter((change_item :any)=> change_item.scenario_detail_id !== item.scenario_detail_id);
      this.price_changed_items.push(item);
      this.addPriceChangedItem(itemCode, newPrice);
    }
    this.zeroValidation();
  }

  removePriceChangeItem(itemCode: any) {
    this.price_change.forEach((value: boolean, key: number) => {
      if (itemCode == key) {
        this.price_change.delete(itemCode);
      }
    });
  }

  /** Add Price Changed Item in the Map */
  addPriceChangedItem(itemCode: any, newPrice: any) {
    this.price_change.set(itemCode, this.utilService.validateNumberCheck(newPrice))
  }

  /** zero validation */
  zeroValidation() {
    this.is_validate_price_enable = false;
    for (let entry of this.price_change.entries()) {
      if (this.price_change.get(entry[constant.common.zero]) == constant.common.zero) {
        this.is_validate_price_enable = true;
        this.zeroValidationMessage();
        break;
      }
    }
  }

  zeroValidationMessage() {
    this.toastrService.warning(this.utilService.languageTranslator(constant.translate_text.valid_price_error), undefined, {closeButton: true});
  }

  /** get Price updated Details */
  getPriceChangeDetails(obj: any) {
    return !this.utilService.isNullOrEmptyOrUndefined(this.price_change.get(obj.scenario_detail_id)) ?
      this.price_change.get(obj.scenario_detail_id) : this.utilService.validateNumberCheck(obj.scenario_price);
  }

  /** Open Confirm Modal For Save PopUp */
  saveSkuLevel() {
    this.sku_level_save_confirm_pupup = constant.common.display_block
  }

  /** Open Save Scenario Input Pop Up */
  openNewScenarioPopup() {
    this.sku_level_save_confirm_pupup = constant.common.display_none
    this.sku_level_new_scenario = constant.common.display_block
    this.name = ''
    this.description = ''
    this.pricing_cycle_date = ''
  }

  /**OnPriceBandChange */
  OnPriceBandChange(event: any) {
    this.applyPriceBandList();
  }

  /** Create Dto for Save Scenario */
  createScenarioDto() {
    if (this.utilService.isNullOrEmptyOrUndefined(this.name) || this.utilService.isNullOrEmptyOrUndefined(this.pt_settings.planning_cycle_date) || this.utilService.isNullOrEmptyOrUndefined(this.description)) {
      this.toastrService.warning(this.utilService.languageTranslator(constant.translate_text.mandatory_validation));
    }
    else {
      let payload = {
        scenario_id: this.urlService.encrypt(this.pt_settings.scenario_id),
        name: this.name,
        description: this.description,
        pricing_cycle_date: this.pt_settings.planning_cycle_date,
        request_id: this.pt_settings.request_id,
        parent_optimizer_id: this.urlService.encrypt(this.pt_settings.parent_optimizer_id) ,
        price_hierarchy: this.getSavePriceHeirarchyData()
      }
      this.createScenario(payload)
    }
  }

  /**Month and Year Selector function */
  setMonthAndYear(event: any, datepicker: MatDatepicker<Moment>){
    const ctrlValue: any = moment();
    ctrlValue.month(event.month());
    ctrlValue.year(event.year());
    this.date.setValue(ctrlValue);
    this.pricing_cycle_date = ctrlValue.format(constant.common.withoutTimezoneConversionwithoutDate);
    datepicker.close();
  }

  /** Api For Save Scenario */
  createScenario(paylaod:any) {
    this.scenerioService.createSKUDetails(paylaod).subscribe({
      next: (response: any) => {
        this.handleCreateScenarioResponse(response);
      },
      error: (error: any) => {
        if (scenario_error[error.status] && scenario_error[error.status][error.error.message])
          this.exceptionService.toastMessage(error.status, this.translateService.instant(scenario_error[error.status][error.error.message]))
        else
          this.exceptionService.toastMessage(error.status, error.body);
      }
    });
  }

  /** Handle Save Scenario Response */
  handleCreateScenarioResponse(response:any){
    this.exceptionService.toastMessage(constant.common.sucess_response, `${this.utilService.languageTranslator(constant.translate_text.scenario_created_message_beginning)}"${response.scenario_name}" ${this.utilService.languageTranslator(constant.translate_text.scenario_created_message_ending)}`);
    this.sku_level_new_scenario = constant.common.display_none
    this.backToScenario()
  }

  /** Close Save Pop UP */
  closePopup() {
    this.sku_level_new_scenario = constant.common.display_none
    this.sku_level_save_confirm_pupup = constant.common.display_none
    this.rules_violation_popup = constant.common.display_none;
    this.reset_recommendation_popup = constant.common.display_none;
    this.reset_current_popup = constant.common.display_none;
  }

  /** Function Call on clear Button of Category Dropdown */
  onClearCategories(){
    this.applied_categories = this.selected_category = []
    this.page_index = constant.common.zero;
    this.page_size = constant.common.default_page_size;
    this.scenario_filters.category_l2 && this.getL2CategoryData();
    this.scenario_filters.subcategory &&this.getSubCategoryData();
    this.scenario_filters.product && this.getProductNameData();
    this.updateTable(false, true)
  }

  /** Function Call on clear Button of Category Dropdown */
  onClearL2Categories() {
    this.applied_categories_l2 = this.selected_category_l2 = []
    this.page_index = constant.common.zero;
    this.page_size = constant.common.default_page_size;
    this.scenario_filters.category_l1 && this.getCategoryData();
    this.scenario_filters.subcategory && this.getSubCategoryData();
    this.scenario_filters.category_l2 && this.getProductNameData();
    this.updateTable(false, true)
  }

  /** Function Call on clear Button of Category Dropdown */
  onClearSubCategories() {
    this.applied_sub_categories = this.selected_sub_category = []
    this.page_index = constant.common.zero;
    this.page_size = constant.common.default_page_size;
    this.scenario_filters.category_l1 && this.getCategoryData();
    this.scenario_filters.category_l2 &&this.getL2CategoryData();
    this.scenario_filters.product &&this.getProductNameData();
    this.updateTable(false, true)
  }

  /** Function Call on clear Button of Price Band Dropdown */
  onClearPriceBand(){
    this.applied_price_band = this.selected_price_band = constant.common.defaultRegion;
    this.geo_code = constant.common.defaultRegionCode;
    this.geo_id = constant.common.defaultRegionId;
    this.page_index = constant.common.zero;
    this.page_size = constant.common.default_page_size;
    this.updateTable(false, true)
  }

  /** Function Call on clear Button of Product Name Dropdown */
  onClearProductName(){
    this.applied_product_name = this.selected_product_name = []
    this.page_index = constant.common.zero;
    this.page_size = constant.common.default_page_size;
    this.scenario_filters.category_l1 && this.getCategoryData();
    this.scenario_filters.category_l2 && this.getL2CategoryData();
    this.scenario_filters.subcategory && this.getSubCategoryData();
    this.updateTable(false, true)
  }

  /** Function Call on apply Button of Price Band Dropdown */
  applyPriceBandList(){
    this.applied_price_band = this.selected_price_band;
    this.geo_code = this.applied_price_band.geo_code;
    this.geo_id = this.applied_price_band.geo_id;
    this.page_index = constant.common.zero;
    this.page_size = constant.common.default_page_size;
    this.updateTable(false,true)
  }

  /** Function Call on apply Button of Product Name Dropdown */
  applyProductNameList(){
    this.applied_product_name = this.selected_product_name;
    this.page_index = constant.common.zero;
    this.page_size = constant.common.default_page_size;
    this.scenario_filters.category_l1 && this.getCategoryData();
    this.scenario_filters.category_l2 && this.getL2CategoryData();
    this.scenario_filters.subcategory && this.getSubCategoryData();
    this.updateTable(false,true)
  }

  /** Function Call on apply Button of Category Dropdown */
  applyCategoryList() {
    this.applied_categories = this.selected_category;
    this.page_index = constant.common.zero;
    this.page_size = constant.common.default_page_size;
    this.scenario_filters.category_l2 && this.getL2CategoryData();
    this.scenario_filters.subcategory && this.getSubCategoryData();
    this.scenario_filters.product && this.getProductNameData();
    this.updateTable(false, true);
  }

  /** Function Call on apply Button of L2 Category Dropdown */
  applyCategoryL2List() {
    this.applied_categories_l2 = this.selected_category_l2;
    this.page_index = constant.common.zero;
    this.page_size = constant.common.default_page_size;
    this.scenario_filters.category_l1 && this.getCategoryData()
    this.scenario_filters.subcategory && this.getSubCategoryData();
    this.scenario_filters.product && this.getProductNameData();
    this.updateTable(false, true);
  }

  /** Function Call on apply Button of SUB Category Dropdown */
  applySubCategoryList() {
    this.applied_sub_categories = this.selected_sub_category;
    this.page_index = constant.common.zero;
    this.page_size = constant.common.default_page_size;
    this.scenario_filters.category_l1 && this.getCategoryData();
    this.scenario_filters.category_l2 && this.getL2CategoryData();
    this.scenario_filters.product && this.getProductNameData();
    this.updateTable(false, true);
  }

  /** Function for Recalculate DTO */
  recalculateImpactDto(recalculation_type: any, function_type: any) {
    // close the popup
    this.reset_recommendation_popup = constant.common.display_none;
    this.reset_current_popup = constant.common.display_none;
    if(this.recalculation_type[recalculation_type] == this.recalculation_type.current_price || this.recalculation_type[recalculation_type] == this.recalculation_type.recommendation_price){
      this.is_reset_price_hierarchy = true;
    }
    else{
      this.is_reset_price_hierarchy = false;
    }

    if(this.is_file_uploaded && this.recalculation_type[recalculation_type] == this.recalculation_type.price_change){
      recalculation_type = 'upload_item_calculation'
    }
    let recalculate_dto = {
      "scenario_id": this.scenario_id,
      're_calculation_type': this.recalculation_type[recalculation_type],
      "function_calculation_type": this.function_calculation_type[function_type],
      "price_changed_items": (this.recalculation_type[recalculation_type] == this.recalculation_type.price_change || this.recalculation_type[recalculation_type] == this.recalculation_type.upload_item_calculation) ? this.priceChangeDetailsforRecalculate() : undefined,
      "request_id": this.pt_settings.request_id,
      "parent_optimizer_id": this.pt_settings.parent_optimizer_id,
      "planning_cycle_date": this.pt_settings.planning_cycle_date
    }
    this.recalculateImpact(recalculate_dto)
  }

  /** Function for Data to send for recalculate on Price Change */
  priceChangeDetailsforRecalculate() {
    return Array.from(this.price_change.entries()).map(([key, value]) => {
      let [geo_code, sku01] = key.split(':');
      geo_code = parseInt(geo_code)
      return {
        geo_code,
        sku01,
        scenario_price: this.getPriceChangeDetails({ scenario_detail_id : key })
      };
    });
  }

  /** Function to call Api for Recalculate Impact API */
  recalculateImpact(recalculate_dto: any) {
    this.scenerioService.recalculateImpact(recalculate_dto).subscribe({
      next: (response: any) => {
        this.handleRecalculateResponse(response)
      },
      error: (error: any) => {
        this.exceptionService.toastMessage(error.status, this.translateService.instant(this.recalculate_errors[error.status][error.error.message]));
      }
    })
  }
  /** Function To Handle Recalculate Response */
  handleRecalculateResponse(response: any) {
    if(this.is_reset_price_hierarchy){
      this.pbrSettings = { ...this.pbrSettings, price_hierarchy_data: undefined }
      this.is_reset_price_hierarchy = false;
    }
    if (response && !this.utilService.isNullOrEmptyOrUndefined(response?.items_affected)) {
      this.is_item_recalculated = true;
      this.is_file_uploaded = false;
      this.exceptionService.toastMessage(
        constant.common.sucess_response,
        (this.item_affected ?? response.items_affected) + this.translateService.instant(constant.scenario.recalculated_rows)
      );
      if(response?.message?.price_change_items && Object.keys(response?.message?.price_change_items).length>0){
        this.is_recalculate_price_change = true;
      }
    }
    this.item_affected = null;
    this.is_rule_violation = response?.message?.rule_validation_status === 0;
    this.is_rule_violation ? this.openRulesViolationPopup() : this.updateTable(true, true);
    this.rule_violation_path = response?.message?.rule_validation_path
    this.is_alert_toggle_disabled = true;
    this.updateUrlParams();
    this.price_change.clear();
  }

  /** Function When Category Dropdown Hides */
  onCategoryHide(){
   this.selected_category=this.applied_categories
  }

  /** Function When Category Dropdown Hides */
  onPriceBandHide(){
   this.selected_price_band = this.applied_price_band;
  }

  /** Function When Category Dropdown Hides */
  onProductNameHide(){
   this.selected_product_name = this.applied_product_name;
  }

  /** Page Change Function */
  pageEvent(event: PageEvent) {
    this.page_index = event.pageIndex;
    this.page_size = event.pageSize;
    this.updateTable()
  }

  /** Sort Data Function */
  sortData(sort: Sort){
    this.sorting_column = constant.sortHeaders_sku_table[sort.active];
    this.sorting_type = sort.direction;
    this.updateTable()
  }

  /** Updating Table After Filter/Sorting/Recalculation */
  updateTable(recalculation?:boolean, filter?:boolean){
    let categories_lvl1: any = this.selected_category.map((value: any) => {
      return this.urlService.encrypt(value.category_lvl1_id );
    });
    let categories_lvl2 : any = this.selected_category_l2.map((value: any) => {
      return this.urlService.encrypt(value.category_lvl2_id );
    });
    let sub_category : any = this.selected_sub_category.map((value: any) => {
      return this.urlService.encrypt(value.sub_category_id);
    });
    let geo_code: any = this.geo_code.toString();
    let geo_id :any = this.geo_id.toString();
    let product_name: any = this.selected_product_name.map((value: any) => {
      return this.urlService.encrypt(value.product_id);
    });
    if(filter) {
      this.page_index = constant.common.zero;;
    }
    this.paginationCall.emit({page_index: this.page_index, page_size:this.page_size, categories_lvl1: categories_lvl1, sorting_column:this.sorting_column, sorting_type:this.sorting_type, recalculation: recalculation, filter:filter, geo_code: geo_code, geo_id: geo_id, productNames: product_name,filter_with_estimates: geo_code, is_recommended_price_change:this.is_recommended_price_change, is_producted_affected: this.is_producted_affected, is_price_change: this.is_price_change,categories_lvl2: categories_lvl2, sub_category: sub_category, price_analysis_required: this.price_analysis_required});
  }

  /** Clear Selected Columns */
  clearSelectedColumns() {
    this.selected_column = [];
    this.price_tier_table_columns = constant.scenario.table_columns_with_price_tier;
  }

  /** Apply Selected Columns To Show */
  applySelectedColumns() {
    this.price_tier_table_columns = constant.scenario.common_columns.concat(this.selected_column.map((value: any) => {
      return value['column_id'];
    }));
    if(this.pt_settings.view_price_band_scenario == true) this.price_tier_table_columns = this.price_tier_table_columns.filter((item:any) => item !== 'price_tier');
  }

  /** Function to Download Scenario Excel */
  downloadScenario(){
    this.scenerioService.downloadScenario(this.getDownloadDto()).subscribe({
      next: (response:any)=>{
        this.utilService.download(response, constant.donwloadFormates.excel.value, this.translateService.instant(constant.scenario.file_name)+this.scenario_id);
        this.exceptionService.toastMessage(constant.common.sucess_response,this.translateService.instant(constant.common.download_success));
      },
      error:(error:any)=>{}
    })
  }

  /** Download Dto Funtion */
  getDownloadDto(){
    return {
      "scenario_id": this.urlService.encrypt(this.scenario_id),
      "request_id":  this.pt_settings.request_id
    }
  }

  /** Upload Dto Funtion */
  uploadScenarioDto(fileEvent:any): void{
    const formdata = new FormData();
    formdata.append('file',fileEvent.target.files[0]);
    formdata.append('scenario_id',this.urlService.encrypt(this.scenario_id));
    formdata.append('request_id', this.pt_settings.request_id)
    this.uploadScenario(formdata);
    fileEvent.target.value = null;
  }

  /** Function to Upload Scenario Excel */
  uploadScenario(formdata: FormData){
    this.scenerioService.uploadScenario(formdata).subscribe({
      next:  (response:any)=>{
        this.is_file_uploaded = true;
        this.recalculateImpactDto('price_change','recalculate');
        this.item_affected = response.items_affected;
      },
      error:(error:any)=>{
        this.exceptionService.toastMessage(error.status, this.translateService.instant(uploadError[error.error.message]));
      }
    }
     )
  }

  /** Open Rule Violation Popup Function */
  openRulesViolationPopup(){
    this.rules_violation_popup = constant.common.display_block;
  }

  /** Override Rule Violation Function */
  overrideViolation() {
    this.updateTable(true, true);
    this.exceptionService.toastMessage(constant.common.sucess_response, this.translateService.instant(constant.scenario.override_successful));
  }

  fixMannually(){
    this.updateTable(false,true);
  }

  overrideDto() {
    return {
      'scenario_id': this.scenario_id,
      'request_id': this.pt_settings.request_id
    }
  }

  /** Download Violation */
  downloadViolation() {
    this.scenerioService.downloadViolation(this.downloadViolationDto()).subscribe({
      next: (response: any) => {
        this.utilService.download(response, constant.donwloadFormates.excel.value, this.translateService.instant(constant.scenario.violation_file_name) + this.scenario_id);
        this.exceptionService.toastMessage(constant.common.sucess_response, this.translateService.instant(constant.common.download_success));
      },
      error: (error: any) => { }
    })
  }

  downloadViolationDto() {
    return {
      "rule_validation_path": this.rule_violation_path
    }
  }

  /** Update URL Params Based on if File is Uploaded or Item has been recalculated */
  updateUrlParams(): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {pbrSettings: this.urlService.encryptUsingAES256(JSON.stringify({...this.pbrSettings,is_upload: this.is_file_uploaded, is_calculated:this.is_item_recalculated, is_rule_violation: this.is_rule_violation,is_alert_toggle_disabled:this.is_alert_toggle_disabled, is_recalculate_price_change : this.is_recalculate_price_change}))},
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  /** To Open Price Heirarchy Popup */
  openPriceHierarchyPopup(){
    let categories_lvl1: any = []
    if (this.selected_category.length > 0) {
      categories_lvl1 = this.selected_category.map((value: any) => {
        return value.category_lvl1_id;
      });
    }
    else {
      categories_lvl1 = this.category_data.map((value: any) => {
        return value.category_lvl1_id;
      });
    }
      this.price_hierarchy_pop_up_settings ={
        open: constant.common.display_block,
        categorieIds: categories_lvl1,
      }
  }

  /** Get Price Hierarchy Data From Price Hierarchy Popup Component */
  getpriceHeirarchyChangedData(value:any){
    let categories_lvl1: any = this.selected_category.map((value: any) => {
      return this.urlService.encrypt(value.category_lvl1_id );
    });
    let categories_lvl2 : any = this.selected_category_l2.map((value: any) => {
      return this.urlService.encrypt(value.category_lvl2_id );
    });
    let sub_category : any = this.selected_sub_category.map((value: any) => {
      return this.urlService.encrypt(value.sub_category_id);
    });
    let product_name: any = this.selected_product_name.map((value: any) => {
      return this.urlService.encrypt(value.product_id);
    });
    const savePriceHierarchyDto : any  ={
      "scenario_id": this.scenario_id,
      're_calculation_type': this.recalculation_type.price_hierarchy,
      "function_calculation_type": this.function_calculation_type.recalculate,
      "price_hierarchy_details": value,
      "request_id": this.pt_settings.request_id,
      "parent_optimizer_id": this.pt_settings.parent_optimizer_id,
      'is_recommended_price_change' : this.is_recommended_price_change,
      'is_producted_affected' : this.is_producted_affected,
      'is_price_changed' : this.is_price_change,
      'product_id' : product_name,
      'category_lvl2_id' : categories_lvl2,
      'sub_category' : sub_category,
      "price_analysis_required" : this.price_analysis_required,
      'category_lvl1_id' : categories_lvl1,
      "planning_cycle_date": this.pt_settings.planning_cycle_date
    }
    this.recalculateImpact(savePriceHierarchyDto);
  }

  /** Price Metric Calculation With Percentage Decimal */
  priceMetricCalculationWithThousands(value: any) {
    return this.utilService.priceMetricCalculationWithThousandsService(value, constant.impact_screen.absolute_decimal);
  }

  /** Open Confirm Modal For reset to recommended price */
  openResetToRecommendationPopup() {
    this.reset_recommendation_popup = constant.common.display_block;
  }

  /** Open Confirm Modal For reset to current */
  openResetToCurrentPopup() {
    this.reset_current_popup = constant.common.display_block;
  }
  

  /** Create Price Hierarchy JSON for Save Scenario */
  getSavePriceHeirarchyData(){
    const save_price_hierarchy_data:any= [];
    this.pbrSettings?.price_hierarchy_data?.forEach((item:any) => {
      const { geo_code, geo_name, ...categories } = item;
      Object.keys(categories).forEach(category => {
        const categoryDetails = categories[category];
        if (typeof categoryDetails === 'object' && categoryDetails !== null) {
          save_price_hierarchy_data.push({
            "geo_code": geo_code,
            "geo_name": geo_name,
            "skun02": category,
            "sku02": categoryDetails.sku02,
            "value": parseInt(categoryDetails.value)
          });
        }
      });
    });
    return save_price_hierarchy_data
}

  clearData(parentArray:any, childArray:any, id:any) {
    const parentIds = new Set(parentArray?.map((parent:any) => parent[id]));
    for (let i = childArray.length - 1; i >= 0; i--) {
      if (!parentIds.has(childArray[i][id])) {
        childArray.splice(i, 1); // Remove element from array
      }
    }
  }

  resetFliters(){
    this.applied_categories = this.selected_category = [];
    this.applied_categories_l2 = this.selected_category_l2 = [];
    this.applied_sub_categories = this.selected_sub_category = [];
    this.applied_product_name = this.selected_product_name = [];
    this.is_price_change = false;
    this.is_recommended_price_change = false;
    this.is_producted_affected = false;
    this.price_analysis_required = false;
    this.applied_price_band = this.selected_price_band = constant.common.defaultRegion;
    this.onClearCategories();
    this.scenario_filters.category_l1 && this.getCategoryData();
    this.clearSelectedColumns();
  }

  /** New Product Validation based on Existing Product and Recalculate Price Change */
  checkForNewProductValidation(data:any){
    return data?.price_analysis_required && !data?.price_analysis_reason && (!this.is_recalculate_price_change || (data.current_price == data.existing_price && data.recommended_price == data.existing_price))
  }

  CheckForEmptyFilter(){
   return typeof this.scenario_filters == 'object'
  }

  checkForPriceSenstivity(priceSensitivity:any){
    if(priceSensitivity in Object.keys(this.price_sensitivity)){
      return true
    }
    return false
  }
}
